import { render, staticRenderFns } from "./PctTierView.vue?vue&type=template&id=2ea09332&scoped=true"
import script from "./PctTierView.vue?vue&type=script&lang=js"
export * from "./PctTierView.vue?vue&type=script&lang=js"
import style0 from "./PctTierView.vue?vue&type=style&index=0&id=2ea09332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea09332",
  null
  
)

export default component.exports